import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import GridItem from "@/modules/club-grounds/components/GridItem.vue";
import DevelopmentActionSheet from "@/modules/club-grounds/components/DevelopmentActionSheet.vue";
import { app } from "@/di";
import SlotDeveloper from "@/modules/club-grounds/services/SlotDeveloper";
export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableSlot',
  props: {
    groundSlot: null,
    team: null
  },
  emits: ['update'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const developmentActionSheet = ref();
    const message = useMessage();
    const onBuy = async type => {
      await app.get(SlotDeveloper).queue(props.groundSlot, type);
      message.success(translator.t('done'));
      emit('update');
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(GridItem, {
        color: _ctx.ColorEnum.Cyan
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.CheckRound,
          size: "3rem",
          class: "mb-1"
        }, null, 8, ["icon"]), _createVNode(_component_NButton, {
          secondary: "",
          type: "primary",
          size: "small",
          class: "mt-2",
          onClick: _cache[0] || (_cache[0] = () => developmentActionSheet.value.show())
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.Crane
          }, null, 8, ["icon"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["color"]), _createVNode(DevelopmentActionSheet, {
        ref_key: "developmentActionSheet",
        ref: developmentActionSheet,
        "ground-slot": __props.groundSlot,
        onApply: onBuy
      }, null, 8, ["ground-slot"])], 64);
    };
  }
});